import { ref, set, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from "../../../context/actions";
import GetAuthUserDataInFirebase from "./GetAgencyMemberDataInFirebase";

const AddAuthUserDataInFirebase = async (state, dispatch, authUserId, businessIds, authUsername, userId, authPhone, providerId) => {
    const USERID = userId ? userId : state?.USERID;

    console.log("userid", USERID);

    if (!USERID || !authUserId) return null;

    try {

        const sharedWithRef = ref(
            database,
            `invoiceGenerator/users/${USERID}/sharedWith/${authUserId}`
        );

        const userRef = ref(
            database,
            `invoiceGenerator/sharedWithUsers/${authUserId}`
        );

        /* ---------- ADMIN -> MEMBER ACCESS ---------- */
        await set(sharedWithRef, {
            company: businessIds,
            createdAt: Date.now().toString(),
            updatedAt: Date.now().toString(),
            version: process.env.REACT_APP_VERSION,
            name: (authUsername && authUsername !== "No Name") ? authUsername : (authPhone || "No Name"),
            platform: "website",
            providerId: providerId || "password" // fallback to password if not provided
        });

        /* ---------- MEMBER -> ADMINS MAPPING ---------- */

        const snapshot = await get(userRef);

        let ownerIds = [];

        if (snapshot.exists()) {
            ownerIds = snapshot.val().ownerIds || [];
        }

        // append owner if not already present
        if (!ownerIds.includes(USERID)) {
            ownerIds.push(USERID);
        }

        await set(userRef, {
            ownerIds
        });

        // dispatch({
        //     type: actionType.AGENCYMEMBER,
        //     payload: businessIds
        // });

        // await GetAuthUserDataInFirebase(state, dispatch, USERID);

        return { success: true, message: "User assigned successfully!" };

    } catch (error) {

        console.error("Firebase Error:", error);

        return {
            success: false,
            message: error.message || "Failed to assign user"
        };

    }
};

export default AddAuthUserDataInFirebase;